import { type UseMutationResult, useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useSeenApi } from '#src/contexts/seen-api/useSeenApi.ts'
import { useErrorToast } from '#src/hooks/useErrorToast.ts'

interface UseMetriportRefreshResult {
  refresh: () => void
  isRefreshing: boolean
  error: Error | null
}

export function useMetriportRefresh(
  participantId: string | undefined
): UseMetriportRefreshResult {
  const { seenApi } = useSeenApi()

  const mutation: UseMutationResult<any, Error, void> = useMutation({
    mutationFn: async () => {
      if (!participantId) {
        throw new Error('Participant ID is required for refresh')
      }

      const response = await seenApi.post('/participant/metriport-refresh', {
        participantId,
      })
      if (response.status !== 200) {
        throw new Error('Failed to initiate Metriport records pulls')
      }

      return response.data
    },
    onSuccess: () => {
      toast.success(
        'Metriport records pulls have been initiated successfully. This may take upwards of 10 minutes to complete.'
      )
    },
  })
  useErrorToast(mutation.error?.message)

  return {
    refresh: mutation.mutate,
    isRefreshing: mutation.isPending,
    error: mutation.error,
  }
}
